import React from "react";
import Image from "../elements/Image";
import nodatafound from "../../assets/images/nodatafound.png";

const ProductDescriptionItem = ({ data }) => {
  return (
    <>
      {data?.long_description ? (
        <div className="w-2xl bg-white rounded-md md:px-10 px-5 py-5 shadow-md flex">
          <div
            className="relative text-base"
            dangerouslySetInnerHTML={{
              __html: data?.long_description,
            }}
          />
        </div>
      ) : (
        <div className="flex flex-col items-center md:space-y-4 space-y-2 md:mt-8 mt-4">
          <div className="md:w-28 md:h-28 w-20 h-20 rounded-full bg-[#F0F9F4] overflow-hidden flex items-center justify-center">
            <div className="text-[#e73737] md:text-7xl text-5xl">
              <i className="fa-regular fa fa-exclamation"></i>
            </div>
          </div>
          <div className="text-cape-cod  md:text-3xl text-2xl text-center">
            No Description Available.
          </div>
          <div className="text-concord text-base max-w-md text-center">
            Sorry, no data available at the moment. Please check back later or
            try adjusting your search criteria.
          </div>
        </div>
      )}
    </>
  );
};

export default ProductDescriptionItem;
